import { render, staticRenderFns } from "./CeldaQR.vue?vue&type=template&id=f2895418&scoped=true"
import script from "./CeldaQR.vue?vue&type=script&lang=js"
export * from "./CeldaQR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2895418",
  null
  
)

export default component.exports